import React, {useRef, useCallback, forwardRef} from 'react';

const ChatScrollList = forwardRef(
    ({ data, renderItem, isLoadingMore, hasMore, onEndReached, scrollFadeClass }, ref) => {
        const containerRef = useRef();
        const observerRef = useRef();

        const lastItemRef = useCallback(
            (node) => {
                if (isLoadingMore || !hasMore || !containerRef.current) return;
                if (observerRef.current) observerRef.current.disconnect();

                observerRef.current = new IntersectionObserver(
                    (entries) => {
                        if (entries[0].isIntersecting) {
                            onEndReached && onEndReached();
                        }
                    },
                    {
                        root: containerRef.current,
                        rootMargin: '0px',
                        threshold: 1.0,
                    }
                );

                if (node) observerRef.current.observe(node);
            },
            [isLoadingMore, hasMore, onEndReached]
        );

        return (
            <div
                className={scrollFadeClass}
                ref={containerRef}
                style={{
                    overflowY: 'auto',
                }}
            >
                {data.length > 0 && data.map((item, index) => (
                    <div key={index} ref={index === data.length - 1 ? lastItemRef : null}>
                        {renderItem(item, index)}
                    </div>
                ))}
            </div>
        );
    }
);

export default ChatScrollList;